import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../../../constants'
import {
  VendorUsersResponse,
  VendorUsersRequest,
  VendorCategoriesRequest
} from './types'
import { FilterListResponse } from '../../types'

const fetcher = new Fetcher({})

export const getVendorsList = async (id, role, data) =>
  fetcher.request<VendorUsersRequest, VendorUsersResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      API_DICTIONARY.VENDOR
    }${id}/${role ? role + '/' : ''}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getContractCategoriesList = async (id, role) =>
  fetcher.request<VendorCategoriesRequest, FilterListResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      API_DICTIONARY.VENDOR
    }${id}/${role ? role + '/' : ''}${API_DICTIONARY.CONTRACT_CATEGORIES}`,
    method: HTTP_METHODS.GET
  })
